import { combineReducers } from 'redux';
import { Authentication, GetClientIPsWithRefer} from './AuthReducer'//Importar reducer
import {
  CreditOption, AsignateCreditOption, CobranzaPagos, GeneraCobranzaUnico, CobranzaCobro,
  RegisterUserGoalData, UserGoalData, DependenciesData, CalculateDataFile
} from './CreditReducer'
import {
  Document,
  DocumentUploadEvidence,
  UploadSections,
  UploadDocuments,
  DocumentView,
  AutographSign,
  OcrData,
  MetadaData,
  FacialComparison,
  UploadVideoEvidenceContentJsonResult,
  RegisteredData,
  ValIdentityData,
  GetValIdentityData,
  UploadDocSectionContent,
  UploadMinutiaData,
  DigitSingSATData,
  CargaDocWithSecData,
} from './DocumentsReducer'
import { Search, CustomCatalogData } from './ExecuteSearchReducer'
import {
  File,
  FileInfo,
  FileCheck,
  FileText,
  FolioRemote,
  FileCheckAcceptance,
  OptionsToSelect,
  FilesSearch,
  FolioInfo,
  GroupSearch,
  Actors,
  GroupNameData,
  NewActor,
  StartActor,
  DeletedActor,
  UpdatedInfo,
  ManualConfigurations,
  ContinueStageActorSelect,
  FileInfoFolioData,
  FolioExterno,
  FileByGUID,
  GetSurveyQuestions,
} from './FileReducer'
import { ProductRemote } from './ProductReducer'
import { RegChangePass, RecoverChangePassword } from './UserReducer'
import { BioResult } from './BiometricReducer';
import {
  PINActivateUser,
  VALCAPTCHA,
  ValidateChangPass,
  DocumentValidation
} from './ValidationReducer'
import {
  Workflow,
  WorkflowRes,
  ContinueWorkflow,
  CancelWorkFlow,
  WorkflowDefinicion,
  Binnacle,
  RegStatusStage
} from './WorkflowReducer'
import {
  ReSendNip,
  SendNip,
  UpdateMetadata,
  QrImage,
  NotificationChangePass
} from './NotificationReducer'
import { GraphData } from './GraphReducer';
import { QrUid, QrUidData, AssociatedFile } from './QrCodeReducer';
import { DocumentCertificate, RegisterCertificate } from './CertificateReducer'
import { IndentificationCaptureData, AddTitleLegoData, SetDefualtLanguage } from './GenericReducer'
import { GetSignatureRequestsByUsuario, UploadBatchSign } from './FileMasiveReducer'
import { PresentationVCRemote } from './PresentationVCReducer';

const rootReducer = combineReducers({
  Authentication,// combinar reducers
  PresentationVCRemote,
  GetClientIPsWithRefer,
  Workflow,
  WorkflowRes,
  File,
  FileByGUID,
  FileInfo,
  GetSurveyQuestions,
  FileText,
  FileCheck,
  FileCheckAcceptance,
  FilesSearch,
  GroupSearch,
  GroupNameData,
  NewActor,
  StartActor,
  DeletedActor,
  UpdatedInfo,
  Actors,
  FolioInfo,
  OptionsToSelect,
  Search,
  Document,
  DocumentView,
  UploadDocuments,
  UploadSections,
  OcrData,
  MetadaData,
  FacialComparison,
  RegisteredData,
  ContinueWorkflow,
  DocumentUploadEvidence,
  CreditOption,
  AsignateCreditOption,
  ProductRemote,
  PINActivateUser,
  VALCAPTCHA,
  FolioRemote,
  CancelWorkFlow,
  SendNip,
  ReSendNip,
  ValidateChangPass,
  RegChangePass,
  UpdateMetadata,
  NotificationChangePass,
  QrImage,
  AutographSign,
  BioResult,
  WorkflowDefinicion,
  Binnacle,
  DocumentValidation,
  GraphData,
  QrUid,
  QrUidData,
  AssociatedFile,
  ValIdentityData,
  GetValIdentityData,
  UploadDocSectionContent,
  DocumentCertificate,
  RegisterCertificate,
  UploadVideoEvidenceContentJsonResult,
  RegStatusStage,
  UploadMinutiaData,
  CobranzaPagos,
  GeneraCobranzaUnico,
  ManualConfigurations,
  CobranzaCobro,
  DigitSingSATData,
  ContinueStageActorSelect,
  UserGoalData,
  RegisterUserGoalData,
  FileInfoFolioData,
  DependenciesData,
  CalculateDataFile,
  FolioExterno,
  CargaDocWithSecData,
  IndentificationCaptureData,
  AddTitleLegoData,
  SetDefualtLanguage,
  RecoverChangePassword,
  CustomCatalogData,
  GetSignatureRequestsByUsuario,
  UploadBatchSign,

});

export default rootReducer;